
import './hireNewCreditLimitBanner.scss';

import React from 'react';
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
import { i18n } from 'core/i18n';
const { FormattedText, getLanguage } = i18n;
const { formatAmountObject } = require('utilities/currencyHelper');
const { EURO_TEXT } = require('constants/index');
const HireNewCreditLimitBanner = ({
    bannerImage,
    maximumLimitAuthorize,
    bannerSubtitle,
    changeCreditLimitMessages
}) => {
    const amountObj = {
        amount: maximumLimitAuthorize,
        currency: EURO_TEXT
    };
    return (
        <div className="header_card_container__banner_card">
            <div className="header_card_container__banner_container">
                <div className="image">
                    <img
                        alt={'icon'}
                        className="uploaded-document-row__banner_preview-img"
                        src={bannerImage}
                    />
                </div>
                <div className="body">
                    {changeCreditLimitMessages ? (
                        <div className="body__change_credit_limit_message">
                            <div className="body__banner_title">
                                <FormattedText value={'hireNewCreditCard-creditLimitBannerTitle'} />
                                <OneLineSymbolAmount
                                    amountObject={amountObj}
                                    language={getLanguage()}
                                    amountObjectFormatted={formatAmountObject(amountObj, true)}
                                    trimDecimals={true}
                                />
                            </div>
                            <div className="body__banner_subTitle">
                            <FormattedText value={'changeNewCreditLimit-creditLimitBannerSubTitle'} />
                            </div>   
                        </div>
                    ) : (
                        <>
                            <div className="body__banner_title">
                                <FormattedText value={'hireNewCreditCard-creditLimitBannerTitle'} />
                                <OneLineSymbolAmount
                                    amountObject={amountObj}
                                    language={getLanguage()}
                                    amountObjectFormatted={formatAmountObject(amountObj, true)}
                                    trimDecimals={true}
                                />
                                <FormattedText value={'hireNewCreditCard-creditLimitBannerTitleEnd'} />
                            </div>
                            {bannerSubtitle && (
                                <div className="body__banner_subTitle">
                                    <FormattedText value={bannerSubtitle} />
                                </div>
                            )}
                        </>
                    )}
                </div>
            </div>
        </div>
    );

}
export default HireNewCreditLimitBanner;